import { Button, Confirm, Icon, Modal, Table } from 'semantic-ui-react';
import { getALlPublishedVersionById, IPublishedContent, toggleApproved, toggleDisable } from '../../../actions/publisherAction';
import moment from 'moment/moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IState } from 'reducers/reducers';
import { CustomTypeWithPublishState } from '../CustomTypeEditor';

export interface PublisherModalRef {
  setOpen: (open: boolean) => void;
  // isOpen: boolean;
}

type Props = {
  entry?: CustomTypeWithPublishState;
  _ref: React.MutableRefObject<PublisherModalRef | undefined>;
};

export function PublisherVersionsModal({ _ref, entry }: Props) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const allRevisions = useSelector<IState, IPublishedContent[]>((state) => state.publishContent.getAll || []);

  const [showDisablePopup, setShowDisablePopup] = useState(false);
  const [showApproveButton, setShowApproveButton] = useState(true);
  const [showApprovePopup, setShowApprovePopup] = useState(false);

  const sortedRevisions = allRevisions ? allRevisions.sort((a, b) => b.version - a.version) : [];
  const liveIndex = sortedRevisions.findIndex((revision) => revision.approved && !revision.disabled);
  const previewIndex = sortedRevisions.findIndex((revision) => !revision.disabled);

  const handleApprove = (id: string, originalId: string) => {
    dispatch(toggleApproved({ id, originalId }));
  };

  const handleDisable = (id: string, originalId: string) => {
    dispatch(toggleDisable({ id, originalId }));
  };

  useEffect(() => {
    if (!entry?._id) return;

    dispatch(getALlPublishedVersionById(entry?._id));
  }, [entry?._id, dispatch]);

  useEffect(() => {
    if (!_ref) return;

    // eslint-disable-next-line no-param-reassign
    _ref.current = { setOpen };
  }, [_ref, setOpen]);

  return (
    <Modal size="large" open={open} onClose={() => setOpen(false)} onOpen={() => setOpen(true)}>
      <Modal.Header> Version history</Modal.Header>
      <Modal.Content>
        <Table sortable celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Version</Table.HeaderCell>
              <Table.HeaderCell>Published at</Table.HeaderCell>
              <Table.HeaderCell>Published by</Table.HeaderCell>
              <Table.HeaderCell>Disable</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {sortedRevisions.map((e, index) => {
              const showRollback = previewIndex === index;
              const isPublic = liveIndex === index;
              // eslint-disable-next-line no-nested-ternary
              const backgroundColor = isPublic ? '#9adfaa' : e.disabled ? '#eee' : 'white';

              return (
                <Table.Row key={e._id}>
                  <Table.Cell style={{ backgroundColor }}>{e.version}</Table.Cell>
                  <Table.Cell style={{ backgroundColor }}>{moment(e.publishedAt).format('D-M-YYYY - HH:mm')}</Table.Cell>
                  <Table.Cell style={{ backgroundColor }}>{e.publishedBy}</Table.Cell>
                  <Table.Cell style={{ backgroundColor }} collapsing textAlign="center">
                    {e.disabled && <div>Rolled back</div>}
                    {isPublic && <div>Public</div>}
                    {!e.disabled && e.approved && <Icon name="check circle outline" size="large" />}
                    {showRollback && (
                      <>
                        <Button
                          disabled={previewIndex === sortedRevisions.length - 1 ? true : undefined}
                          negative
                          onClick={() => setShowDisablePopup(true)}
                        >
                          Roll back
                        </Button>
                        {!e.approved && showApproveButton && (
                          <Button disabled={showApprovePopup} primary onClick={() => setShowApprovePopup(true)}>
                            Approve
                          </Button>
                        )}
                      </>
                    )}
                    {showRollback && (
                      <>
                        <Confirm
                          open={showApprovePopup}
                          content="Are you sure you want to Approve this version?"
                          confirmButton="OK"
                          onCancel={() => {
                            setShowApprovePopup(false);
                            setShowApproveButton(false);
                          }}
                          onConfirm={() => {
                            handleApprove(e._id, e.originalId);
                            setShowApprovePopup(false);
                            setShowApproveButton(true);
                          }}
                        />
                        <Confirm
                          open={showDisablePopup}
                          content="Are you sure you want to disable this version?"
                          confirmButton="OK"
                          onCancel={() => setShowDisablePopup(false)}
                          onConfirm={() => {
                            handleDisable(e._id, e.originalId);
                            setShowDisablePopup(false);
                          }}
                        />
                      </>
                    )}
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </Modal.Content>
    </Modal>
  );
}
